import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const SocialHandleInput = ({ platform, value, onChange, error }) => {
  const platformConfig = {
    instagram: {
      icon: 'Instagram',
      placeholder: '@username',
      prefix: 'instagram.com/',
      color: '#E4405F'
    },
    tiktok: {
      icon: 'Music',
      placeholder: '@username',
      prefix: 'tiktok.com/@',
      color: '#000000'
    },
    youtube: {
      icon: 'Youtube',
      placeholder: '@channelname',
      prefix: 'youtube.com/@',
      color: '#FF0000'
    },
    twitter: {
      icon: 'Twitter',
      placeholder: '@username',
      prefix: 'twitter.com/',
      color: '#1DA1F2'
    }
  };

  const config = platformConfig?.[platform];

  return (
    <div className="mb-4">
      <div className="flex items-center gap-2 mb-2">
        <Icon name={config?.icon} size={20} color={config?.color} />
        <label className="text-sm md:text-base font-medium text-[var(--color-foreground)] capitalize">
          {platform}
        </label>
      </div>
      <Input
        type="text"
        placeholder={config?.placeholder}
        value={value}
        onChange={(e) => onChange(platform, e?.target?.value)}
        error={error}
        className="w-full"
      />
      <p className="mt-1 text-xs text-[var(--color-muted-foreground)]">
        {config?.prefix}
      </p>
    </div>
  );
};

export default SocialHandleInput;